
namespace Serenity.Criteria {
    export const TOKEN_IDENTIFIER = 1;
    export const TOKEN_OPERATOR = 2;
    export const TOKEN_VALUE = 3;

    export interface Token {
        t: number;
        v: any;
    }

    export interface ParseError {
        error: string;
        pos: number;
    }

    function ParseError(expression: string, error: string, position: number) {
        this.expression = expression;
        this.error = error;
        this.position = position;
        this.toString = function () {
            return 'Error parsing expression: "' + expression + '", "' +
                error + ', position: ' + position;
        };
    }

    export function tokenize(expression: string): Token[] {
        var end: number, v: any;
        var tokens: Token[] = [];
        var l = expression.length;
        var l1 = expression.length - 1;
        var openParens = 0;

        for (var index = 0; index < l; index++) {
            var ch = expression.charAt(index);
            if (ch === ' ' || ch === '\t')
                continue;

            function skipWhiteSpace() {
                while (index < l) {
                    ch = expression.charAt(index);

                    if (ch === ' ' || ch === '\t') {
                        index++;
                        continue;
                    }

                    break;
                }
            }

            function readString() {
                end = index;
                var foundDoubles = false;
                while (end++ < l1) {
                    ch = expression.charAt(end);
                    if (ch === "'") {
                        if (end < l1 && expression.charAt(end + 1) === "'") {
                            end++;
                            foundDoubles = true;
                            continue;
                        }
                        else
                            break;
                    }
                }

                if (end === index ||
                    expression.charAt(end) !== "'")
                    throw new ParseError(expression, 'unterminated string', index);

                v = expression.substr(index + 1, end - index - 1);
                if (foundDoubles)
                    v = v.replace(/''/g, "'");
            }

            function readNumber() {
                end = index;
                var foundDot = false;
                while (end < l1) {
                    ch = expression.charAt(end + 1);
                    if ((ch >= '0' && ch <= '9') ||
                        (!foundDot && (ch === '.'))) {
                        if (ch === '.')
                            foundDot = true;
                        end++;
                    }
                    else
                        break;
                }

                v = parseFloat(expression.substr(index, end - index + 1));
                if (isNaN(v))
                    throw new ParseError(expression, 'invalid number', index);
            }

            function readArrayList() {
                skipWhiteSpace();

                if (index >= l || expression.charAt(index) != '(')
                    throw new ParseError(expression, 'expected parenthesis', index);

                index++;

                let values = [];

                while (true) {
                    skipWhiteSpace();

                    if (index >= l)
                        throw new ParseError(expression, 'expected parenthesis', index);

                    ch = expression.charAt(index);

                    if (ch == ',') {
                        if (values.length == 0)
                            throw new ParseError(expression, 'unexpected comma', index);
                        index++;
                        skipWhiteSpace();
                        ch = expression.charAt(index);
                    }
                    else if (ch == ')') {
                        break;
                    }
                    else if (values.length > 0)
                        throw new ParseError(expression, 'expected comma', index);


                    if (ch === "'") {
                        readString();

                        values.push(v);
                        index = end + 1;
                        continue;
                    }

                    if (ch >= '0' && ch <= '9') {
                        readNumber();

                        values.push(v);
                        index = end + 1;
                        continue;
                    }

                    if (ch == 'n') {
                        readIdentifier();

                        if (v === 'null') {
                            values.push(null)
                            index = end + 1;
                            continue;
                        }
                    }

                    throw new ParseError(expression, 'unexpected token', index);
                }

                v = values;
            }

            if (ch == '_' ||
                (ch >= 'A' && ch <= 'Z') ||
                (ch >= 'a' && ch <= 'z')) {
                function readIdentifier() {
                    end = index;
                    while (end < l1) {
                        ch = expression.charAt(end + 1);
                        if (ch == '_' ||
                            (ch >= 'A' && ch <= 'Z') ||
                            (ch >= 'a' && ch <= 'z') ||
                            (ch >= '0' && ch <= '9')) {
                            end++;
                        }
                        else
                            break;
                    }

                    v = expression.substr(index, end - index + 1);
                }
                readIdentifier();
                var w = v.toLowerCase();
                if (w == 'is') {
                    index = end + 1;
                    skipWhiteSpace();

                    readIdentifier();
                    w = v.toLowerCase();
                    if (w === 'not') {
                        index = end + 1;
                        skipWhiteSpace();
                        readIdentifier();
                        if (v.toLowerCase() === 'null') {
                            tokens.push({
                                t: TOKEN_OPERATOR,
                                v: Serenity.Criteria.Operator.isNotNull
                            });
                        }
                        else
                            throw new ParseError(expression, 'expected "null"', index);
                    }
                    else if (w === 'null') {
                        tokens.push({
                            t: TOKEN_OPERATOR,
                            v: Serenity.Criteria.Operator.isNull
                        });
                    }
                    else
                        throw new ParseError(expression, 'expected "null" or "not" keyword', index);
                }
                else if (w === 'and' || w === 'or' || w === 'xor') {
                    tokens.push({
                        t: TOKEN_OPERATOR,
                        v: w
                    });
                }
                else if (w === 'not') {
                    const currentEnd = end;

                    index = end + 1;
                    skipWhiteSpace();

                    readIdentifier();
                    w = v.toLowerCase();

                    if (w === 'in') {
                        index = end + 1;

                        tokens.push({
                            t: TOKEN_OPERATOR,
                            v: Serenity.Criteria.Operator.notIn
                        });

                        readArrayList();

                        tokens.push({
                            t: TOKEN_VALUE,
                            v: v
                        });
                    }
                    else if (w === "like") {
                        tokens.push({
                            t: TOKEN_OPERATOR,
                            v: Serenity.Criteria.Operator.notLike
                        });

                        index = end;
                    } else {
                        tokens.push({
                            t: TOKEN_OPERATOR,
                            v: Serenity.Criteria.Operator.not
                        });

                        index = currentEnd;
                    }

                    continue;
                }
                else if (w === 'in') {
                    tokens.push({
                        t: TOKEN_OPERATOR,
                        v: Serenity.Criteria.Operator.in
                    });


                    index = end + 1;

                    readArrayList();

                    tokens.push({
                        t: TOKEN_VALUE,
                        v: v
                    });

                    continue;
                }
                else {
                    tokens.push({
                        t: TOKEN_IDENTIFIER,
                        v: v
                    });
                }

                index = end;
                continue;
            }

            if ((((ch === '-') || (ch === '+')) &&
                index < l1 &&
                expression.charAt(index + 1) >= '0' &&
                expression.charAt(index + 1) <= '9') ||
                (ch >= '0' && ch <= '9')) {
                end = index;
                readNumber();

                tokens.push({
                    t: TOKEN_VALUE,
                    v: v
                });

                index = end;
                continue;
            }

            if (ch === "'") {
                end = index;
                readString();

                tokens.push({
                    t: TOKEN_VALUE,
                    v: v
                });
                index = end;
                continue;
            }

            if (ch === '=') {
                tokens.push({
                    t: TOKEN_OPERATOR,
                    v: ch
                });
                continue;
            }

            if (ch === '(') {
                openParens++;
                tokens.push({
                    t: TOKEN_OPERATOR,
                    v: ch
                });
                continue;
            }

            if (ch == ')') {
                if (openParens <= 0)
                    throw new ParseError(expression, 'unexpected parenthesis', index);

                openParens--;
                tokens.push({
                    t: TOKEN_OPERATOR,
                    v: ch
                });
                continue;
            }

            if (ch === '>' || ch === '<') {
                if (index < l1 &&
                    expression.charAt(index + 1) === '=') {
                    tokens.push({
                        t: TOKEN_OPERATOR,
                        v: ch + '='
                    });
                    index++;
                }
                else {
                    tokens.push({
                        t: TOKEN_OPERATOR,
                        v: ch
                    });
                }
                continue;
            }

            throw new ParseError(expression, 'unknown token', index);
        }

        if (openParens > 0)
            throw new ParseError(expression, 'missing parenthesis', index);

        return tokens;
    }

    const operatorPrecedence = {
        '=': 4,
        '>': 4,
        '<': 4,
        '>=': 4,
        '<=': 4,
        '<>': 4,
        '!=': 4,
        'not': 5,
        'and': 6,
        'like': 7,
        'not like': 7,
        'or': 7,
        'in': 7,
        'is null': 7,
        'is not null': 7
    }

    function shuntingYard(tokens: Token[]): Token[] {
        var result: Token[] = [];
        var stack: Token[] = [];
        for (var token of tokens) {
            if (token.t === TOKEN_OPERATOR) {
                var precedence = operatorPrecedence[token.v];

                if (precedence != null) {
                    while (stack.length) {
                        var prev = stack[stack.length - 1];
                        if (prev.t !== TOKEN_OPERATOR)
                            break;
                        var prevPrecedence = operatorPrecedence[prev.v];
                        if (prevPrecedence == null || prevPrecedence > precedence)
                            break;

                        result.push(stack.pop());
                    }

                    stack.push(token);
                }
                else if (token.v === '(') {
                    stack.push(token);
                }
                else if (token.v === ')') {
                    while (stack.length &&
                        (stack[stack.length - 1].t !== TOKEN_OPERATOR ||
                            stack[stack.length - 1].v !== '(')) {
                        result.push(stack.pop());
                    }

                    stack.pop();
                }
                else
                    result.push(token);
            }
            else
                result.push(token);
        }

        while (stack.length) {
            var tok = stack.pop();

            if (tok.t == TOKEN_OPERATOR &&
                (tok.v === '(' || tok.v === ')'))
                throw "Mismatched parentheses in permission expression!";

            result.push(tok);
        }

        return result;
    }

    function rpnTokensToCriteria(rpnTokens: Token[]): any[] {
        var stack: any[] = [];

        for (var token of rpnTokens) {
            switch (token.t) {
                case TOKEN_IDENTIFIER:
                    {
                        stack.push([token.v]);
                        break;
                    }

                case TOKEN_VALUE:
                    {
                        stack.push(token.v);
                        break;
                    }

                case TOKEN_OPERATOR:
                    {
                        switch (token.v as string) {
                            case 'not':
                            case 'is null':
                            case 'is not null':
                                if (!stack.length)
                                    throw new Error("Unary operator " + token.v + " requires a value!");

                                stack.push([token.v, stack.pop()]);
                                break;
                            default:
                                if (stack.length < 2)
                                    throw new Error("Binary operator " + token.v + " requires two values!");

                                var r = stack.pop();
                                var l = stack.pop();
                                stack.push([l, token.v, r]);
                                break;
                        }
                        break;
                    }
                default:
                    throw new Error("Invalid operator type: " + token.t + "!");
            }
        }

        if (stack.length != 1)
            throw new Error("Error evaluating expression!");

        return stack.pop();
    }

    export function parse(expression: string): any[] {
        var tokens = tokenize(expression);
        var rpnTokens = shuntingYard(tokens);
        return rpnTokensToCriteria(rpnTokens);
    }
}